export default {
  role: {
    Root: 'Root',
    Administrator: 'Administrator',
    Manager: 'Manager',
    Staff: 'Staff',
    Viewer: 'Viewer'
  },
  // ユーザー情報を編集できる権限定義 RoleId: [編集可能なacountのRoleIDのリスト]
  accountEditableRoles: {
    2: [ 2, 3, 4, 7, 8 ],
    3: [ 3, 4, 7, 8 ]
  },
  defaultSettingParams: {
    unit: 'gal',                  // Unit [liter|gal]
    timezone: 'local',            // [utc/local/location]
    pressureUnit: 'MPa',          // [PSI/MPa]
    temperatureUnit: '°C',         // [°C/°F]
    emailNotification: 'disable', // [enable/disable]
    emailLanguage: 'English'      // [English/Japanese]
  },
  organizationConfig: {
    limitCreateHierarchy: {
      max: 2147483647,
      min: 0
    }
  },
  // サービスIDごとに定義
  serviceConfig: {
    1: {
      flow: {
        range: {
          max: 1000000000,
          min: 0
        }
      },
      time: {
        range: {
          max: 120,
          min: 0
        }
      }
    },
    2: {
      ro: {
        range: {
          max: 100,
          min: 0
        }
      }
    },
    3: {}, // 現状定義しておくことはないので器だけ作っておく
    4: {}, // 現状定義しておくことはないので器だけ作っておく
    5: {
      pressure: {
        range: {
          max: 30399000,
          min: 0
        }
      }
    }
  },
  whitelabel: {
    'aqua.harps4.com': {
      supportLanguage: {
        'en': 'English',
        'de': 'Deutsch beta',
        'ja': '日本語'
      },
      emailLanguage: {
        'en': {
          disp: 'English',
          code: 'English'
        },
        'de': {
          disp: 'Deutsch beta',
          code: 'German'
        },
        'ja': {
          disp: '日本語',
          code: 'Japanese'
        }
      },
      topnav: {
        flag: '1',  // 1:text,2:img
        text: 'HARPS',
        class: 'blue--text text--darken-2'
      },
      domain: 'aqua.harps4.com',
      copyright: 'Copyright © 2018-2019 Aplix and/or its affiliates. All rights reserved.',
      title: ' | HARPS',
      path: 'aqua_harps4_com',
      translations: {
        home: {
          information: 'HARPS'
        }
      }
    },
    'connect.ecosoft.com': { // 本番環境用ECONNECT設定
      supportLanguage: {
        'en': 'English',
        'de': 'Deutsch beta',
        'ru': 'Russian',
        'ja': '日本語'
      },
      emailLanguage: {
        'en': {
          disp: 'English',
          code: 'English'
        },
        'ru': {
          disp: 'Russian',
          code: 'Russian'
        }
      },
      topnav: {
        flag: '2',  // 1:text,2:img
        text: '',
        class: ''
      },
      domain: 'connect.ecosoft.com',
      copyright: '©︎2018-2019 Ecosoft water professionals.',
      title: ' | ECONNECT',
      path: 'connect_ecosoft_com',
      translations: {
        home: {
          information: 'ECONNECT'
        }
      }
    },
    'ecosoft-connect.harps4.com': { // 検証環境用ECONNECT設定
      supportLanguage: {
        'en': 'English',
        'de': 'Deutsch beta',
        'ru': 'Russian',
        'ja': '日本語'
      },
      emailLanguage: {
        'en': {
          disp: 'English',
          code: 'English'
        },
        'ru': {
          disp: 'Russian',
          code: 'Russian'
        }
      },
      topnav: {
        flag: '2',  // 1:text,2:img
        text: '',
        class: ''
      },
      domain: 'connect.ecosoft.com',
      copyright: '©︎2018-2019 Ecosoft water professionals.',
      title: ' | ECONNECT',
      path: 'connect_ecosoft_com',
      translations: {
        home: {
          information: 'ECONNECT'
        }
      }
    },
    'titanium.britapro.harps4.com': { // 本番環境用Brita PRO設定
      supportLanguage: {
        'en': 'English',
        'de': 'Deutsch beta',
        'ja': '日本語'
      },
      emailLanguage: {
        'en': {
          disp: 'English',
          code: 'English'
        },
        'de': {
          disp: 'Deutsch beta',
          code: 'German'
        },
        'ja': {
          disp: '日本語',
          code: 'Japanese'
        }
      },
      topnav: {
        flag: '2',  // 1:text,2:img
        text: '',
        class: ''
      },
      domain: 'titanium.britapro.harps4.com',
      copyright: 'Copyright © 2018-2019 Protect Plus PRO LLC. All Rights Reserved.',
      title: ' | Brita PRO',
      path: 'protectplus_britapro_com',
      translations: {
        home: {
          information: 'Brita PRO'
        }
      }
    },
    'britapro-titanium.harps4.com': { // 検証環境用Brita PRO設定
      supportLanguage: {
        'en': 'English',
        'de': 'Deutsch beta',
        'ja': '日本語'
      },
      emailLanguage: {
        'en': {
          disp: 'English',
          code: 'English'
        },
        'de': {
          disp: 'Deutsch beta',
          code: 'German'
        },
        'ja': {
          disp: '日本語',
          code: 'Japanese'
        }
      },
      topnav: {
        flag: '2',  // 1:text,2:img
        text: '',
        class: ''
      },
      domain: 'titanium.britapro.harps4.com',
      copyright: 'Copyright © 2018-2019 Protect Plus PRO LLC. All Rights Reserved.',
      title: ' | Brita PRO',
      path: 'protectplus_britapro_com',
      translations: {
        home: {
          information: 'Brita PRO'
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/config.js